/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the payment
 * * unknown    - Payment resource has been created in vipps, but the outcome is so far unknown.
 *                The client should keep polling for status updates until it sees a different status
 * * cancelable - Payment is held by Vipps (typically due to transient technical errors) and can be
 *                cancelled by the user. No money has been charged.
 * * pending    - Payment was in cancelable state, but is now being processed.
 * * ok         - Payment completed successfully
 * * failed     - Payment failed, e.g. due to insufficient funds.
 * @export
 */
export const PaymentStatus = {
    Unknown: 'unknown',
    Pending: 'pending',
    Cancelable: 'cancelable',
    Ok: 'ok',
    Failed: 'failed'
} as const;
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


export function PaymentStatusFromJSON(json: any): PaymentStatus {
    return PaymentStatusFromJSONTyped(json, false);
}

export function PaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStatus {
    return json as PaymentStatus;
}

export function PaymentStatusToJSON(value?: PaymentStatus | null): any {
    return value as any;
}

